import React,{Component} from 'react'
import {Link} from 'react-router-dom'

export default class Company extends Component{
    render(){
        return <div className={'company-section-container'}>
            <div className={'header-with-gradient'}>
                <div className={'details-head'}>
                    <div className={'head'}>Company</div>
                </div>
            </div>
            <div className={'details'}>
                <div className={'head'}>We help people navigate digital workplaces through process management and automation</div>
                <p>Hubbler is a one-of-a-kind SaaS product company helping enterprises manage, digitize, automate and optimize business processes with ease. We enable the development of customizable digital business applications with simple, user-friendly automation solutions.</p>
                <p> Founded in 2016, the company has led to the successful digital transformation of 20+ SME and large customers across industry verticals and functions. </p>
            </div>
            <div className={'company-image'}></div>
            <div className={'company-info'}>
                <div className={'image'}></div>
                <div className={'content'}>
                    <div className={'head'}>Designing a people-first workplace</div>
                    <p>Hubbler’s mission is to design solutions for people. We embrace a people-first workplace strategy to help collaborate better, engage efficiently, and manage productivity. Hubbler introduces the digital workforce to a seamless, code-free, plug-and-play experience of app development. </p>
                </div>
            </div>
            <div className={'company-info reverse'}>
                <div className={'image'}></div>
                <div className={'content'}>
                    <div className={'head'}>Building a smart digital workplace</div>
                    <p>With over 200+ ready-to-use apps and services, Hubbler’s platform is a powerful tool that integrates workflows, communications and analytics modules for enterprises of any size. Create your own app or pick and customize from our range of pre-built apps for quick deployment and integration with your existing and future systems and data sources.  </p>
                </div>
            </div>
            <div className={'information-content'}>
                <div className={'information-content-sub'}>
                    <div className={'head'}>We’re changing how enterprises manage their business processes</div>
                    <p>At Hubbler, we are building transformative collaborative tools to build better teams, connect people, and make processes more efficient. Our tools help enterprises automate and scale in a jiffy – fast tracking growth and development.</p>
                </div>
            </div>
            <div className={'join-team'}>
                <div className={'head'}>Join our team</div>
                <Link className={'bt'} to="/career/?view=openPositions">See Open Positions</Link>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/pages/company/aboutus.js